import { Injector } from "@angular/core";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeAuthorisedProduct } from "../Entity/TreeNodeAuthorisedProduct";
import { TreeNodeProductAttachment } from "../Entity/TreeNodeProductAttachment";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeProductAttachmentList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Product Attachments ({param})');
      this.parent = parent;
      this.labelNodeName = 'Product Attachments';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeProductAttachment(this.ioc!, this);
      this.children?.push(node);
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let ppiattachments: Art57Node[] = [];
      this.children?.forEach((node) => {
        let ppiattachment = node as Art57Node;
        ppiattachments.push(ppiattachment.getMessage());
      });
      if (ppiattachments.length > 0) {
        return { ppiattachments: { ppiattachment: ppiattachments } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Attachment name'];
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (this.parent instanceof TreeNodeAuthorisedProduct) {
        if ((!this.ioc!.get(AuthService).isEMAOrganisation()) &&
            (!this.children || this.children.length == 0) &&
            ([1,2].includes(this.parent.data.model.operationtype)) 
          ) {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.bussinessValidationError,
            controlId: undefined,
            controlLabel: '',
            error: 'Section is Mandatory',
          });
        } else if (this.children && this.children?.length > 30) {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.bussinessValidationError,
            controlId: undefined,
            controlLabel: '',
            error: "The maximum number of attachments allowed is 30",
          });
        } else {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.errorInactive,
            controlId: undefined,
            controlLabel: '',
            error: '',
          });
        }
      }

      return errors;


      return errors;
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeProductAttachmentList =
        new TreeNodeProductAttachmentList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }

  